import Vue from "vue";
import Router from "vue-router";
import { Auth } from "aws-amplify";
import { loadMessages } from "./i18n";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home"),
      meta: { requiresAuth: true, showToolbar: true },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login"),
      meta: { showToolbar: true },
    },
    {
      path: "/signup",
      name: "signup",
      component: () => import("./views/CreateAccount"),
      meta: { showToolbar: true },
    },
    {
      path: "/password-reset",
      name: "password-reset",
      component: () => import("./views/PasswordReset"),
      meta: { showToolbar: true },
    },
    {
      path: "/disclaimer",
      name: "disclaimer",
      component: () => import("./views/Disclaimer"),
      meta: { showToolbar: true },
    },
    {
      path: "/project-unavailable",
      name: "no-project",
      component: () => import("./views/NoProject"),
      meta: { showToolbar: true },
    },
    {
      path: "/project/:id",
      name: "project",
      component: () => import("./views/Project"),
      meta: { requiresAuth: true },
    },
    {
      path: "/maintenance",
      name: "maintenance",
      component: () => import("./views/Maintenance"),
      meta: { requiresAuth: true, showToolbar: true },
    },
    {
      path: "/project/:id/copy",
      name: "create-duplicate",
      component: () => import("./views/CreateDuplicate"),
      meta: { requiresAuth: true },
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});

router.beforeEach((to, from, next) => {
  loadMessages().then(() => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      Auth.currentSession()
        .then(() => {
          next();
        })
        .catch(() => {
          next({
            path: "/login",
            query: { redirect: to.fullPath },
          });
        });
    } else {
      if (Object.keys(from.query).length && !Object.keys(to.query).length) {
        next({ name: to.name, query: from.query });
      } else {
        next();
      }
    }
  });
});

export default router;
